import { createQueryUrl } from 'components/SearchSideBar/logics/createSearchResultPageUrl';
import { SelectedCurrentConditionType } from 'types/searchCondition';
import { DEFAULT_PARAMS } from '../../../../constants';
import { createUrl } from '../../logics/createUrl';
import { createConditionQueryObject } from './createConditionQueryObject';

/**
 * moveToSearchResultPageの引数
 */
interface ArgumentType {
  /** 選択された検索条件 */
  featuredSelectedSearchCondition: SelectedCurrentConditionType;
  /** 特集枠案件IDクエリ */
  fidQuery: string | undefined;
}

/**
 * 遷移先URLの生成処理を実行し遷移する
 *
 * @param {ArgumentType} params - 遷移処理に渡される引数
 */
export const moveToSearchResultPage = ({
  featuredSelectedSearchCondition,
  fidQuery,
}: ArgumentType) => {
  // 検索条件のクエリ文字列を生成
  const searchConditionQuery = createQueryUrl(
    createConditionQueryObject({
      selectedCurrentCondition: featuredSelectedSearchCondition,
      defaultParams: DEFAULT_PARAMS,
      fidQuery,
    })
  );

  const url = createUrl(searchConditionQuery);

  window.location.href = url;
};
